"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var billing;
        (function (billing) {
            var billableUsers;
            (function (billableUsers) {
                class InitArgs {
                    constructor() {
                        this.billingId = 0;
                        this.billingBillableUsers = appn.emptyString;
                        this.exportBillableUserRows = appn.emptyString;
                        this.exportBillableUserActivityRows = appn.emptyString;
                    }
                }
                let _initArgs;
                let _dtKeys = ['clients-table', 'activated0', 'deactivated0', 'inactive3', 'inactive6', 'inactive12'];
                billableUsers._dts = [];
                let _userDataTable = null;
                let totalTables = 0;
                let dataTable = null;
                function init(args) {
                    _initArgs = args;
                    createDataTables();
                    addEvents();
                }
                billableUsers.init = init;
                function createDataTables() {
                    dataTable = appn.dataTable.create('.clientsTable', {
                        iDisplayLength: 25,
                        oLanguage: {
                            sInfoEmpty: appn.emptyString
                        },
                        aaSorting: [[1, 'desc']],
                        fnInitComplete: function () {
                            appn.dataTable.addSearchPlaceholder(T('Filter results where the Billable Users <b>Client Name, User Id, or Email</b> contains a keyword typed in here'));
                            appn.saveMeState.init(function () {
                                dataTable.fnDraw(false);
                            }, function () {
                                dataTable.fnDraw(false);
                            }, '.dataTables_filter');
                        },
                        fnDrawCallback: function () {
                            $('.toggleuserlist').off().on('click', function () {
                                if ($(this).hasClass('open')) {
                                    $(this).text('show users');
                                    $(this).siblings('.userAuditTable').hide();
                                    $(this).removeClass('open');
                                    appn.dataTable.redrawOnResize();
                                    return;
                                }
                                $(this).text('hide users');
                                $(this).siblings('.userAuditTable').show();
                                $(this).addClass('open');
                                appn.dataTable.redrawOnResize();
                            });
                        }
                    });
                    _dtKeys.forEach((dt) => {
                        const dataTable = appn.dataTable.create(`.${dt}`, {
                            sDom: appn.dataTable.genSDom(0, 0, 1),
                            iDisplayLength: 25,
                            oLanguage: {
                                sInfoEmpty: appn.emptyString
                            },
                            aaSorting: [[1, 'desc']]
                        });
                        billableUsers._dts.push(dataTable);
                    });
                }
                function renderTableOnOpen(className) {
                    const currentTable = getTableByClassName(className);
                    setTimeout(function () { currentTable.fnDraw(false); }, 200);
                }
                function getTableByClassName(className) {
                    return billableUsers._dts.filter((dt) => dt['0'].classList.contains(className))[0];
                }
                function addEvents() {
                    $('#exportUsers').off().on('click', function (event) {
                        event.preventDefault();
                        appn.ajax.get({
                            url: _initArgs.exportBillableUserRows
                                + appn.location.buildQueryString([
                                    { name: 'billingId', value: _initArgs.billingId },
                                    { name: 'server', value: $('#serverFilter').val() },
                                    { name: 'year', value: $('#yearFilter').val() },
                                    { name: 'month', value: $('#monthFilter').val() },
                                    { name: 'showall', value: $('#ShowAllSelected').is(':checked') }
                                ]),
                            done: function () {
                                appn.notifications.updateNotificationTotal();
                            }
                        });
                        appn.ui.showExportConfirmation('Billable Users');
                    });
                    $('#exportUsersActivity').off().on('click', function (event) {
                        event.preventDefault();
                        appn.ajax.get({
                            url: _initArgs.exportBillableUserActivityRows
                                + appn.location.buildQueryString([
                                    { name: 'billingId', value: _initArgs.billingId },
                                    { name: 'server', value: $('#serverFilter').val() },
                                    { name: 'numberOfMonths', value: $('#exportPeriod').val() },
                                    { name: 'showall', value: $('#ShowAllSelected').is(':checked') }
                                ]),
                            done: function () {
                                appn.notifications.updateNotificationTotal();
                            }
                        });
                        appn.ui.showExportConfirmation('Billable Users Activity');
                    });
                    $('#export').on('click', function (event) {
                        $('#exportDialog').modal('show');
                    });
                    $('#activatedUsers').on('click', function (event) {
                        $('#activatedUserDialog').modal('show');
                        renderTableOnOpen(_dtKeys[1]);
                    });
                    $('#deactivatedUsers').on('click', function (event) {
                        $('#deactivatedUserDialog').modal('show');
                        renderTableOnOpen(_dtKeys[2]);
                    });
                    $('#inactiveUsersThree').on('click', function (event) {
                        $('#inactiveThreeUserDialog').modal('show');
                        renderTableOnOpen(_dtKeys[3]);
                    });
                    $('#inactiveUsersSix').on('click', function (event) {
                        $('#inactiveSixUserDialog').modal('show');
                        renderTableOnOpen(_dtKeys[4]);
                    });
                    $('#inactiveUsersTwelve').on('click', function (event) {
                        $('#inactiveTwelveUserDialog').modal('show');
                        renderTableOnOpen(_dtKeys[5]);
                    });
                    $('#monthFilter').change(function () {
                        reloadPage();
                    });
                    $('#yearFilter').change(function () {
                        reloadPage();
                    });
                    $('#serverFilter').change(function () {
                        reloadPage();
                    });
                    $('#ShowAllSelected').change(function () {
                        reloadPage();
                    });
                    $(document).on('click', '.toggle-user-list', function () {
                        const tr = $(this).closest('tr');
                        const tableKey = $(this).closest('table').data("table-key");
                        const table = getTableByClassName(tableKey);
                        if (table.fnIsOpen(tr)) {
                            table.fnClose(tr);
                            $(this).html(T('show users'));
                            return;
                        }
                        totalTables += 1;
                        table.fnOpen(tr, $(tr.find('.users-table-container').html()).addClass('user-table-show_' + totalTables.toString()), 'info_row');
                        createUsersDataTable('.user-table-show_' + totalTables.toString(), tableKey);
                        $(this).html(T('hide users'));
                    });
                    $(document).on('click', '.btn-resetFilters', function (e) {
                        dataTable.clearSearch();
                    });
                }
                function createUsersDataTable(tableClass, tableKey) {
                    if (tableKey == 'activated0' || tableKey.contains('inactive')) {
                        _userDataTable = appn.dataTable.create(tableClass, {
                            sDom: appn.dataTable.genSDom(0, 0, 0),
                            paging: false,
                            info: false,
                            aaSorting: [[3, 'desc']],
                            aoColumns: [
                                { sWidth: '5%' },
                                { sWidth: '40%' },
                                { sWidth: '25%' },
                                { sType: 'string', sWidth: '30%' },
                            ],
                            iDisplayLength: -1,
                            noFilterKey: true
                        });
                        return;
                    }
                    _userDataTable = appn.dataTable.create(tableClass, {
                        sDom: appn.dataTable.genSDom(0, 0, 0),
                        paging: false,
                        info: false,
                        aaSorting: [[3, 'desc']],
                        aoColumns: [
                            { sWidth: '5%' },
                            { sWidth: '20%' },
                            { sWidth: '15%' },
                            { sType: 'string', sWidth: '20%' },
                            { sType: 'string', sWidth: '20%' },
                            { sWidth: '20%' }
                        ],
                        iDisplayLength: -1,
                        noFilterKey: true
                    });
                }
                function reloadPage() {
                    appn.location.navTo(_initArgs.billingBillableUsers, [
                        { name: 'server', value: $('#serverFilter').val() },
                        { name: 'year', value: $('#yearFilter').val() },
                        { name: 'month', value: $('#monthFilter').val() },
                        { name: 'showall', value: $('#ShowAllSelected').is(':checked') }
                    ]);
                }
            })(billableUsers = billing.billableUsers || (billing.billableUsers = {}));
        })(billing = views.billing || (views.billing = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
